import { render, staticRenderFns } from "./chatActiveSession.vue?vue&type=template&id=357e5ad5&scoped=true"
import script from "./chatActiveSession.vue?vue&type=script&lang=js"
export * from "./chatActiveSession.vue?vue&type=script&lang=js"
import style0 from "./chatActiveSession.vue?vue&type=style&index=0&id=357e5ad5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "357e5ad5",
  null
  
)

export default component.exports